import { convertCocosModel } from '@/api/common/convert'

export default async function (
  { commit, state, dispatch }: any,
  {
    file_url,
    mod,
    model,
    tpl_id,
    preset,
    textures,
    rotate,
  }: {
    file_url: string
    mod: string
    model: string
    tpl_id: number
    preset?: 1 | 0
    textures?: string[]
    rotate?: number
  },
) {
  commit('setLoading', true)
  const task = convertCocosModel({
    file_url,
    mod,
    model,
    tpl_id,
    preset,
    textures,
    rotate,
  })
  task.finally(() => {
    commit('setLoading', false)
  })
  return task
}
